import React, {useState, useCallback, useRef, useEffect} from 'react';
import t from 'babel-plugin-yate/macro';
import get from 'lodash-es/get';
import {Form, Field} from 'react-final-form';

import {isRequired} from '../../lib/validations';
import errorFocus from '../../lib/errorFocus';
import {Block, Text} from '../../components/uiElem';
import Button from '../../components/Button';
import {Input} from '../../components/Form/Input';
import {DocumentsUploadBox} from '../../components/DocumentsUploadBox';
import {useUploadFile} from '../../lib/useUploadFile';
import Address from '../../components/Address';

const DOC_TYPE_ADDRESS = 'address';

function Step2Address(props) {
  const {data, patchHandler, uuid} = props;
  const {file, uploading, uploaded, fetch, upload} = useUploadFile({
    cbOnSuccess: () => patchHandler({}, true),
  });
  const formRef = useRef();
  const [btnDisabled, setBtnDisabled] = useState(false);

  const hasInitialBirthPlace = get(data, 'customer.identity_card.birth_place');

  const handleAddressFormData = useCallback(
    async values => {
      setBtnDisabled(true);

      let payload = values;
      patchHandler(payload);
      setBtnDisabled(false);
    },
    [patchHandler],
  );

  useEffect(() => {
    fetch(DOC_TYPE_ADDRESS);
  }, [fetch]);

  return (
    <div className="relative">
      <Form
        keepDirtyOnReinitialize={true}
        onSubmit={handleAddressFormData}
        formRef={formRef}
        initialValues={{
          customer: {
            identity_card: {
              ...(data?.customer.identity_card ?? {}),
            },
          },
        }}
        render={({handleSubmit, submitFailed, submitSucceeded, form}) => {
          return (
            <form onSubmit={handleSubmit} ref={formRef}>
              <div className="lg:flex -ml-10">
                <div className="lg:w-full pl-10">
                  <Block heading={t`Informatii CI`}>
                    <div className="pt-8 p-2">
                      <Address
                        displayFullAddressId={true}
                        defaultValueLabel="identity_card.address"
                        form={form}
                        uuid={uuid}
                      />

                      <div className="w-full px-2 mb-4">
                        <Field
                          name="customer.identity_card.birth_place"
                          label={t`Locul nasterii`}
                          component={Input}
                          disabled={hasInitialBirthPlace}
                          validate={isRequired()}
                        />
                      </div>
                    </div>
                  </Block>
                </div>

                <div className="lg:w-1/2 pl-10">
                  <Block heading={t`Incarca dovada adresei de domiciliu`}>
                    <Text ui="jupiter" className="pt-8 px-4">
                      {t`Factura de utilitati de la adresa de domiciliu, extras de cont pe numele solicitantului de credit, certificat privind domiciliul sau resedinta.`}
                    </Text>

                    <DocumentsUploadBox
                      acceptFileTypes="image/*,.pdf"
                      description={t`Accepted file types: ${'.pdf, .jpg, .jpeg, .png'}.`}
                      isFileUploaded={uploaded[DOC_TYPE_ADDRESS]}
                      isFileMissing={
                        (submitFailed || submitSucceeded) &&
                        !uploaded[DOC_TYPE_ADDRESS]
                      }
                      isLoading={uploading[DOC_TYPE_ADDRESS]}
                      onUpload={f => upload(f, DOC_TYPE_ADDRESS)}
                      uploadInputLabel={t`Upload document`}
                      documents={file[DOC_TYPE_ADDRESS]}
                      showDownloadLink={true}
                    />
                  </Block>
                </div>
              </div>
            </form>
          );
        }}
      />

      <div className="py-6 flex justify-between">
        <div className="w-64 mx-auto sm:mr-0">
          <Button
            fullWidth
            color="orange"
            border={false}
            title={t`Continue`}
            customProps={{disabled: btnDisabled}}
            onClick={() => {
              errorFocus(formRef.current);

              formRef.current.dispatchEvent(
                new Event(
                  'submit',
                  /**
                   * https://github.com/facebook/react/issues/12639
                   */
                  {cancelable: true},
                ),
              );
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default Step2Address;
